<div class="card-body" *ngIf="settingTypeValue == 'export'">
  請選擇要匯出的資料：<br>
  <div style="display: flex; align-items: center;column-gap: 10px;">
    <mat-checkbox *ngFor="let item of exportItemType" [(ngModel)]="item.checked"
      (change)="onCheckboxChange(item)">{{item.text}} </mat-checkbox>

  </div>
</div>

<div class="card-body" *ngIf="settingTypeValue == 'import'">
  <app-vis-button (click)="import()" [label]="'請點擊選擇匯入檔案'" [title]="'匯入'" [icon]="'upload_file'"></app-vis-button>
  <app-vis-button *ngIf="gridView?.data?.length > 1" (click)="pageReset()" [label]="'清除戴入資料'" [title]="'清除戴入資料'"
    [icon]="'clear'"></app-vis-button>
</div>

<div class="card-body">
  <mat-button-toggle-group [(ngModel)]="toggleClick" (ngModelChange)="onBtnToggleClick($event)">
    <ng-container *ngFor="let item of exportItemType">
      <mat-button-toggle *ngIf="item.checked" [value]="item.value">{{item.text}}</mat-button-toggle>
    </ng-container>
  </mat-button-toggle-group>
</div>

<div class="card-body" *ngIf="toggleClick">
  <app-vis-grid [data]="gridView" [attr.disabled]="true" [pageSize]="pageSize" [skip]="pageSkipNo" [pageable]="true"
    (pageChange)="pageChange($event)" [selectable]="true">

    <ng-container *ngIf="toggleClick === 'Parameter'">
      <app-vis-grid-column field="GroupName" title="群組" [width]="100" i18n-title="@@Group"
        class="text-center"></app-vis-grid-column>
      <app-vis-grid-column field="Key" title="代碼" [width]="200" i18n-title="@@Key"></app-vis-grid-column>
      <app-vis-grid-column field="Name" title="名稱" [width]="230" i18n-title="@@Name">
        <ng-template let-data>
          <div [title]="data.Name">{{data.Name}}</div>
        </ng-template>
      </app-vis-grid-column>
      <app-vis-grid-column field="Type" title="型態" [width]="60" [hidden]="true" i18n-title="@@Type" class="text-center">
      </app-vis-grid-column>
      <app-vis-grid-column field="Value" title="值" i18n-title="@@Value" class="text-center"></app-vis-grid-column>
    </ng-container>

    <ng-container *ngIf="toggleClick === 'setting'">
      <app-vis-grid-column field="Type" title="類型" [width]="110" i18n-title="@@Type">
      </app-vis-grid-column>
      <app-vis-grid-column field="Code" title="代碼" [width]="110" i18n-title="@@Code">
      </app-vis-grid-column>
      <app-vis-grid-column field="Name" title="名稱" i18n-title="@@Name" class="custom-name">
      </app-vis-grid-column>
      <app-vis-grid-column field="Name1" title="備註" i18n-title="@@Name1" class="custom-name">
      </app-vis-grid-column>
      <app-vis-grid-column field="Name2" title="其他" i18n-title="@@Name2" class="custom-name">
      </app-vis-grid-column>
      <app-vis-grid-column field="Sort" title="排序" [width]="110" i18n-title="@@SN" class="text-center">
      </app-vis-grid-column>
    </ng-container>

    <ng-container *ngIf="toggleClick === 'cmsReport'">
      <app-vis-grid-column field="Type" title="類型" [width]="110" i18n-title="@@Type">
      </app-vis-grid-column>
      <app-vis-grid-column field="Code" title="樣板代碼" [width]="110" i18n-title="@@Code">
      </app-vis-grid-column>
      <app-vis-grid-column field="Desc" title="名稱/說明" i18n-title="@@Desc" class="custom-name">
      </app-vis-grid-column>
    </ng-container>

    <ng-container *ngIf="toggleClick === 'system-number'">
      <app-vis-grid-column field="RuleCode" title="規則代碼" [width]="60" i18n-title="@@SystemNumberListRuleCode"
        class="pt-1">
      </app-vis-grid-column>
      <app-vis-grid-column field="RuleName" title="規則名稱" [width]="80" i18n-title="@@SystemNumberListRuleName"
        class="pt-1">
      </app-vis-grid-column>
      <app-vis-grid-column field="Repeat" title="重複方式" [width]="60" i18n-title="@@SystemNumberListRepeat"
        class="pt-1 text-center custom-m-auto">
      </app-vis-grid-column>
      <app-vis-grid-column field="Start" title="起始號" [width]="50" i18n-title="@@SystemNumberListStart"
        class="pt-1 text-right">
      </app-vis-grid-column>
      <app-vis-grid-column field="Step" title="間隔號" [width]="50" i18n-title="@@SystemNumberListStep"
        class="pt-1 text-right">
      </app-vis-grid-column>
      <app-vis-grid-column field="End" title="結束號" [width]="50" i18n-title="@@SystemNumberListEnd"
        class="pt-1 text-right">
      </app-vis-grid-column>
      <app-vis-grid-column field="Number" title="目前使用流水號" [width]="100" i18n-title="@@SystemNumberListNumber"
        class="pt-1 text-right">
      </app-vis-grid-column>
      <app-vis-grid-column field="LastTakeTime" title="最後取號時間" [width]="130" i18n-title="@@SystemNumberListLastTakeTime"
        class="pt-1 text-center custom-m-auto">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.LastTakeTime | formatROCTime:'' }}
        </ng-template>
      </app-vis-grid-column>
    </ng-container>

    <ng-container *ngIf="toggleClick === 'registersNumberRule'">
      <app-vis-grid-column field="RoomCode" title="診間號" [width]="60" i18n-title="@@RoomCode" class="pt-1">
      </app-vis-grid-column>
      <app-vis-grid-column field="TimeSection" title="時段" [width]="60" i18n-title="@@TimeSection" class="pt-1">
      </app-vis-grid-column>
      <app-vis-grid-column field="RuleCode" title="規則代號" [width]="60" i18n-title="@@RuleCode" class="pt-1">
      </app-vis-grid-column>
      <app-vis-grid-column field="Start" title="起始號" [width]="60" i18n-title="@@Start" class="pt-1">
      </app-vis-grid-column>
      <app-vis-grid-column field="Step" title="間隔號" [width]="60" i18n-title="@@Step" class="pt-1">
      </app-vis-grid-column>
      <app-vis-grid-column field="End" title="結束號" [width]="60" i18n-title="@@End" class="pt-1">
      </app-vis-grid-column>
      <app-vis-grid-column field="StartDate" title="規則啟用時間" [width]="130" i18n-title="@@StartDate" class="pt-1">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.StartDate | formatROCTime:'' }}
        </ng-template>
      </app-vis-grid-column>
    </ng-container>

  </app-vis-grid>
</div>

<div class="card-body" *ngIf="hasChecked">
  <ng-container *ngFor="let item of exportItemType">
    <div *ngIf="item.checked">
      <span class="fw-bold text-info">{{item.text}}</span> 資料總筆數： {{item.total}}
    </div>
  </ng-container>
  <app-vis-button *ngIf="settingTypeValue == 'export'" (click)="export()" [label]="'匯出'" [title]="'匯出'"
    [icon]="'arrow_upward'"></app-vis-button>
  <app-vis-button (click)="sandImport()" *ngIf="settingTypeValue == 'import' && importData" [label]="'匯入上傳'"
    [title]="'匯入'" [icon]="'cloud_upload'"></app-vis-button>
</div>
